export default (palette, isDarkMode, shadows) => ({
  root: {
    borderRadius: '12px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    border: `1px solid ${palette.divider}`,
    backgroundColor: palette.background.paper,
    boxShadow: isDarkMode ? 'none' : shadows[1],


    '&:hover': {
      boxShadow: isDarkMode ? 'none' : shadows[3],
      transform: 'translateY(-2px)',
    }
  }
})
